import React from "react";
import {
    Card,
    Row,
    Col,
    Button,
    Dropdown,
    Badge,
    Accordion,
    Modal,
    Table
} from "react-bootstrap";
import { connect } from "react-redux";
import { setComputerDetails,setComputerAddEditStatus } from "../../../store/actions/Computers"
import { useImmer } from "use-immer";
import IssueCard from "./Issues/IssueCard"
import IssueAddEdit from "./Issues/IssueAddEdit";
import AddEdit from "../ComputerForm/AddEdit";
import { useEffect } from "react";
import {setIssueAddStatus,deleteIssue} from "../../../store/actions/issues"
import { getAudits } from "../../../store/actions/audit";
import "./DetailView.css";
import { useNavigate } from "react-router-dom";



const DetailsView = ({
    onBack,
    Computer,
    setComputerDetails,
    issues,
    issues_status,
    setIssueAddStatus,
    deleteIssue,
    add_status,
    setComputerAddEditStatus,
    isAdmin,
    auditData,
    getAudits
}) => {
    const onCancel = () => {
        var result = []
        setComputerDetails(result);
        onBack();
    }
    const navigate = useNavigate();

    const[show,setshow]= useImmer(false)

    const initial_state_issues = {
        type:"Add",
        issue_id:"",
        title:"",
        description:"",
        priority:"",
        status:"",
        issued_by: "",
        assignedTo: "",
        reason: ""
    };
    const computerId = Computer?.[0]?.ComputerID || "";
    const[getIssueDetails,SetStateAddEdit]= useImmer(initial_state_issues)
    const onEditIssue = (data) =>{
        SetStateAddEdit((draft) => {
            draft.type= "Edit";
            draft.title = data.title;
            draft.description = data.description;
            draft.priority = data.priority;
            draft.status = data.status;
            draft.issue_id = data.issue_id;
            draft.issued_by = data.issued_by;
            draft.assignedTo = data.assignedTo;
            draft.reason = data.ReasonToResolve;
        });
        setshow(true)
    }
    const onDeleteIssue = (issue_id) =>{
        var data ={
            issue_id: issue_id,
            computer_id: Computer.length > 0? Computer[0].ComputerID:"" 
        }
        deleteIssue(data)
    }
    const onIssueCancel = () =>{
        setshow(false)
        SetStateAddEdit(initial_state_issues)
    }
    const OnAddEdit = () =>{
        setshow(true)
    }
    useEffect(()=>{
        if(issues_status){
            SetStateAddEdit(initial_state_issues)
            setshow(false)
            setIssueAddStatus(false)
        }
    },[issues_status])


    const [getAddEditModel, setAddEditModel] = useImmer(false);
    useEffect(() => {
        if (add_status == true) {
            setAddEditModel(false);
            setComputerAddEditStatus(false);
        }
    }, [add_status])
    const onHideAddModel = () => {
        setAddEditModel(false)
    }


    //Audit
     useEffect(()=>{
         const data = {
           computer_id: computerId
        }
        getAudits(data)
    },[computerId])
    const [showAudit, setShowAudit] = useImmer(false);
    


    return (
        <>
            {
                Computer.length > 0 && (
                    <React.Fragment>
                        <Row>
                            <Col className="d-flex justify-content-start">
                            <Button
                                className="btn btn-primary my-1"
                                onClick={onCancel}
                                title="Go back"
                            >
                                <i className="bi bi-arrow-left"></i> back
                            </Button>
                            </Col>
                            <Col className="d-flex justify-content-end">
                                {isAdmin && (
                                    <Button
                                size="sm"
                                variant="btn btn-primary m-1"
                                onClick={() => {
                                    setAddEditModel(true);
                                }}
                                title="Add new issues"
                            >
                              <i className="bi bi-pencil-fill"></i>  Edit Computer
                            </Button>
                                )}
                            <Button
                                size="sm"
                                className="btn btn-primary m-1"
                                onClick={OnAddEdit}
                                title="Add new issues"
                            >
                              <i className="bi bi-plus"></i>  Add new issue
                            </Button>
                            </Col>
                            
                        </Row>

                        <Card className="computer-details-card shadow-sm">
                            <Card.Body>
                                <Row>
                                    <div className="computer-header d-flex justify-content-between align-items-start">

                                            <div>
                                                <h2 className="computer-title">
                                                    {Computer[0].ComputerName}
                                                </h2>

                                                <div className="computer-subtitle">
                                                    <i className="bi bi-person-circle"></i>
                                                    {Computer[0].Username}
                                                </div>
                                            </div>


                                            <div className="d-flex align-items-center gap-2">

                                                <Button 
                                                    variant="btn btn-primary"
                                                    size="sm"
                                                    onClick={() => setShowAudit(true)}
                                                >
                                                    <i className="bi bi-clock-history me-1"></i>
                                                    Audit History
                                                </Button>


                                                <Badge
                                                    bg={
                                                        Computer[0].licenceType === "Licensed"
                                                            ? "success"
                                                            : Computer[0].licenceType === "OpenSource"
                                                            ? "primary"
                                                            : "danger"
                                                    }
                                                    className="px-3 py-2"
                                                >
                                                    {Computer[0].licenceType}
                                                </Badge>

                                            </div>

                                        </div>

                                    <Dropdown.Divider />
                                    
                                       <Row className="g-3 mt-3">

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                    <i className="bi bi-memory me-1"></i>
                                                     RAM
                                                    </small>
                                                    <h6>{Computer[0].RAM}</h6>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                        <i className="bi bi-speedometer me-1"></i>
                                                        Processor
                                                    </small>
                                                    <h6>{Computer[0].Processor}</h6>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                        <i className="bi bi-laptop me-1"></i>
                                                        Operating System
                                                    </small>
                                                    <h6>{Computer[0].OS}</h6>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                        <i className="bi bi-gear me-1"></i>
                                                        System Type
                                                    </small>
                                                    <h6>{Computer[0].SystemType}</h6>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                        <i className="bi bi-speedometer me-1"></i>
                                                        Architecture
                                                    </small>
                                                    <h6>{Computer[0].Architecture}</h6>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                        <i className="bi bi-speedometer me-1"></i>
                                                        HardwareVersion
                                                    </small>
                                                    <h6>{Computer[0].HardwareVersion}</h6>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                        <i className="bi bi-speedometer me-1"></i>
                                                        BuildNumber
                                                    </small>
                                                    <h6>{Computer[0].BuildNumber}</h6>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="spec-card">
                                                    <small>
                                                        <i className="bi bi-speedometer me-1"></i>
                                                        PhysicalCores
                                                    </small>
                                                    <h6>{Computer[0].PhysicalCores}</h6>
                                                </div>
                                            </Col>


                                        </Row>

                                    <Dropdown.Divider />
                                    
                                    <div className="description-box">

                                        <h5>Description</h5>

                                        <p>

                                            {Computer[0].Description || "No description available."}

                                        </p>

                                    </div>
                                </Row>
                                
                                <Dropdown.Divider />

                                <div className="mt-4">

                                        <div className="software-table-wrapper">
                                            {Computer.filter( (software) => software.SoftwareName || software.SoftwareVersion || software.Publisher || software.CreatedDate ).length > 0 ? (
                                            <Table className="software-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Software</th>
                                                        <th>Version</th>
                                                        <th>Publisher</th>
                                                        <th>Audit Date</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {Computer
                                                        .filter(
                                                            (software) =>
                                                                software.SoftwareName ||
                                                                software.SoftwareVersion ||
                                                                software.Publisher ||
                                                                software.CreatedDate
                                                        )
                                                        .map((software, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="software-name">
                                                                        <i className="bi bi-box-seam me-2"></i>
                                                                        {software.SoftwareName || "-"}
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <span className="software-version">
                                                                        {software.SoftwareVersion || "-"}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    <span className="software-publisher">
                                                                        {software.Publisher || "-"}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    <span className="software-date">
                                                                        {software.CreatedDate
                                                                            ? new Intl.DateTimeFormat("en-IN", {
                                                                                dateStyle: "medium"
                                                                            }).format(
                                                                                new Date(
                                                                                    software.CreatedDate.replace(
                                                                                        " ",
                                                                                        "T"
                                                                                    )
                                                                                )
                                                                            )
                                                                            : "-"}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </Table>
                                            ) : ( <div className="no-software-message"> <i className="bi bi-box-seam"></i> <span>No software installed yet</span> </div> )}
                                        </div>
                                    </div>
                            </Card.Body>
                        </Card>

                        {/* don't anything below */}
                        {issues.length > 0 && (<>
                            <Dropdown.Divider />
                            <strong> Issues:</strong>
                            {
                                issues.map((data) => {
                                    return (
                                        <IssueCard
                                            issue_id={data.issue_id}
                                            title={data.title}
                                            description={data.description}
                                            priority={data.priority}
                                            status={data.status}
                                            issued_date={data.created_date}
                                            IssuedPerson_Name={data.IssuedPerson_Name}
                                            assignee_Name={data.assignee_Name}
                                            reason={data.ReasonToResolve}
                                            issue={data}
                                            editIssue={onEditIssue}
                                            deleteIssue={onDeleteIssue}
                                        />
                                    )
                                })

                            }

                        </>
                        )
                        }
                       
                    </React.Fragment>
                )
            }
            <Modal
                show={showAudit}
                onHide={() => setShowAudit(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="bi bi-clock-history me-2"></i>
                        Audit History
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {auditData.length === 0 ? (

                        <div className="dashboard-empty">
                            <i className="bi bi-clipboard-x"></i>

                            <h6>No audits found</h6>

                            <span>
                                No audit history is available.
                            </span>
                        </div>

                    ) : (

                        <div className="dashboard-items audit-history-items">

                            {auditData.map((audit, index) => (

                                <div
                                    className="dashboard-item audit-item"
                                    key={audit.AuditID || index}
                                >

                                    <div className="dashboard-item-icon">
                                        <i className="bi bi-clipboard-check"></i>
                                    </div>

                                    <div className="dashboard-item-content">

                                        <div className="dashboard-item-top">

                                            <h6>
                                                <i className="bi bi-shield-check me-1"></i>
                                                {getAuditTypeText(audit.AuditType)}
                                            </h6>

                                            <span className="dashboard-item-date">
                                                {audit.AuditTime || "-"}
                                            </span>

                                        </div>

                                        <p>
                                            {audit.AuditInfo ||
                                                "No audit information available"}
                                        </p>

                                    </div>

                                </div>

                            ))}

                        </div>

                    )}

                </Modal.Body>

                <Modal.Footer>

                    <Button
                        variant="btn btn-secondary"
                        onClick={() => setShowAudit(false)}
                    >
                        Close
                    </Button>

                </Modal.Footer>
            </Modal>
             <IssueAddEdit 
             onShow={show}
             onclose ={onIssueCancel}
             computer_id={Computer.length > 0? Computer[0].ComputerID:""}
             issues={getIssueDetails}
             />
             <AddEdit
                type ={"Edit"}
                onShow={getAddEditModel}
                onHide={onHideAddModel}
            />
        </>
    );
}
const getAuditTypeText = (type) => {
    switch (type) {
        case "1":
            return "Login";
        case "127":
            return "USB Activity";
        case "3":
            return "Shutdown";
        case "4":
            return "Software Installed";
        default:
            return "Audit Event";
    }
};
const mapStateToProps = (state) => {
    return {
        Computer: state.computers.computerDetails.length > 0 ? state.computers.computerDetails : [],
        issues: state.computers.issuesDetails.length > 0 ? state.computers.issuesDetails : [],
        issues_status:  state.computers.issue_add_edit_status,
        add_status: state.computers.add_status,
        auditData: state.audit.list.length > 0 ? state.audit.list : []
    };
};
export default connect(mapStateToProps, { setComputerDetails,setIssueAddStatus,deleteIssue,setComputerAddEditStatus, getAudits })(DetailsView);
